// Use Vite's import.meta.glob for reliable JSON bulk import
// Each JSON module has { default: jsonContent } in Vite
import { logger } from '@/utils/logger';

const modules = import.meta.glob('./*.json', { eager: true }) as Record<
  string,
  { default: Record<string, unknown> }
>;

const fr: Record<string, unknown> = {};
for (const [, mod] of Object.entries(modules)) {
  // Vite JSON modules: mod.default is the JSON content
  // Fallback to mod itself in case of different module format
  const content = mod.default ?? mod;
  Object.assign(fr, content);
}

if (import.meta.env.DEV) {
  logger.debug('[i18n barrel] Merged', Object.keys(fr).length, 'top-level keys:', Object.keys(fr));
}

export default fr;
